import {
  CategoryInterface,
  MembershipStatus,
  SpecialServicesTabsIds
} from 'types';

const { Review, Recent, Favorites, Popular, Consultation } =
  SpecialServicesTabsIds;

export const SERVICES_TABS: Record<number, CategoryInterface> = {
  [Review]: {
    id: SpecialServicesTabsIds.Review,
    name: 'Review'
  },
  [Recent]: {
    id: SpecialServicesTabsIds.Recent,
    name: 'My recent services'
  },
  [Favorites]: {
    id: SpecialServicesTabsIds.Favorites,
    name: 'My favorites services'
  },
  [Popular]: {
    id: SpecialServicesTabsIds.Popular,
    name: 'Popular services'
  },
  [Consultation]: {
    id: SpecialServicesTabsIds.Consultation,
    name: 'Consultation'
  }
};

export const availableMembershipSatuses = [
  MembershipStatus.Active,
  MembershipStatus.Pending,
  MembershipStatus.Purchased,
  MembershipStatus.Frozen
];
